// Contexto para anmazenar dados do ID do AutoComplete escolhido

import React, { createContext, useState } from "react";

export const ProfIdContext = createContext()
export const ProfNomeContext = createContext()

export const ProfContextProvider = ({ children }) => {
    const [profIdContext, setProfIdContext] = useState('')
    const [profNomeContext, setProfNomeContext] = useState('')
 
    return (
        <ProfIdContext.Provider value={{ profIdContext, setProfIdContext }}>
            <ProfNomeContext.Provider value={{ profNomeContext, setProfNomeContext }}>
                {children}
            </ProfNomeContext.Provider>
        </ProfIdContext.Provider>
    )
}